var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-carousel"},[_c('div',{staticClass:"horizontal-layout"},_vm._l((_vm.items),function(item,index){return _c('DynamicImageIcon',{key:index,attrs:{"label":item.label,"alt":item.alt,"imgUrl":item.imageSource}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }